import React, { useState, useRef, useEffect } from 'react';
import { BACKEND_URL } from '../Constants';
import './ChatWindow.css';

const ChatWindow = ({ messages, setMessages, setLoading }) => {
  const [userInput, setUserInput] = useState('');
  const chatEndRef = useRef(null);

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const question = userInput.trim();
    if (!question) return;
  
    // Clear input immediately
    setUserInput('');
    setMessages(prev => [...prev, { sender: 'user', text: question }]);
    setLoading(true);
  
    try {
      const res = await fetch(`${BACKEND_URL}/api/faq`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ question })
      });
  
      const { answer, isHTML } = await res.json();
      setMessages(prev => [
        ...prev,
        { sender: 'bot', text: answer, html: isHTML }
      ]);
    } catch (err) {
      setMessages(prev => [
        ...prev,
        { sender: 'bot', text: '😓 Something went wrong. Please try again.' }
      ]);
    }
  
    setLoading(false);
  };
  

  return (
    <>
      <div className="widget__chat-log">
      {messages.map((msg, idx) => (
  msg.html ? (
    <div
      key={idx}
      className={`widget__message widget__message--${msg.sender}`}
      dangerouslySetInnerHTML={{ __html: msg.text }}
    />
  ) : (
    <div
      key={idx}
      className={`widget__message widget__message--${msg.sender}`}
    >
      {msg.text}
    </div>
  )
))}

        <div ref={chatEndRef} />
      </div>

      <form className="widget__input-area" onSubmit={handleSubmit}>
        <input
          className="widget__input"
          type="text"
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          placeholder="Ask a question about the school"
        />
        <button className="widget__send-button" type="submit">Send</button>
      </form>
    </>
  );
};

export default ChatWindow;
